import { lazyWrap } from '@neptune/shared/common-ui';

export const LazyReportsPage = lazyWrap(
  async () => (await import(/* webpackChunkName: "report" */ './ReportsPage')).ReportsPage,
);
